var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouth3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.2 23.8",
    style: {
      enableBackground: "new 0 0 42.2 23.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:#D177B8;}\n\t.st1{fill:#BF336B;}\n\t.st2{fill:#A61A57;}\n\t.st3{fill:#681351;}\n\t.st4{fill:#FFD9FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,10.8c0,0,5.9,13,16.7,13C31.9,23.8,37,12,37,12L4.4,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3,4.2c0,0,5.8,18.1,20.2,18.1c14.4,0,18.7-18.2,18.7-18.2s-12,2.3-15.1,3.7s-5.9,0-8.7-0.9 C13.7,6,1.3,4.2,1.3,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.2,4c0,0,2.7,0.2,7.6-2.2S18,0.1,21.5,0.1v7.7c0,0-7.2-1.6-9.6-1.7S5.7,5.6,2.2,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.8,4c0,0-2.7,0.2-7.6-2.2C28.3-0.6,25,0.1,21.5,0.1v7.7c0,0,7.2-1.6,9.6-1.7C33.6,6.1,37.3,5.6,40.8,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.2,4.1C35.2,6,32.9,5,28,6.3c-4.8,1.4-8.3,1.4-13.2,0s-8.3,0-13.2-2.6C1,3.4,0,2.6,0,2.6v1.2 c0,0,6.7,2.2,11.5,2.5s6.6,3.4,9.9,3.4c3.3,0,5.1-3,9.9-3.4s10.9-2.5,10.9-2.5V2.6C42.2,2.6,40.9,3.9,40.2,4.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "31.8,6.9 35.3,7.9 32.9,10.9 30.8,8.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M29.8,10l1.3,1.6c0,0-1.1-0.8-2.2,0.5c-0.7,0.8-3.7,1.1-4.9,2.1l-0.9-1.7C23.1,12.6,26.7,12.8,29.8,10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouth3);
export default __webpack_public_path__ + "static/media/Mouth3.badb3892a35694e93ad7dceb5dea758a.svg";
export { ForwardRef as ReactComponent };